module.exports = __webpack_public_path__ + "static/media/sell-used-vans-beenleigh.7bf80c3b.png";